import { ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useStyles } from './simulator.styles';
import { InternalLinks } from '../../../../../constants';
import simulatorPreviewMobile from '../../../../../assets/images/simulator/simulator-preview-mobile.png';
import simulatorPreview from '../../../../../assets/images/simulator/simulator-preview.png';
import simulatorPreviewTablet from '../../../../../assets/images/simulator/simulator-preview-tablet.png';
import { ContentWrapper } from '../../../../common/content-wrapper';

export const Simulator = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'xl'));

  const image = useMemo(() => {
    if (isMobile) {
      return {
        src: simulatorPreviewMobile,
        width: 328,
        height: 320,
      };
    } else if (isTablet) {
      return {
        src: simulatorPreviewTablet,
        width: 323,
        height: 257,
      };
    } else {
      return {
        src: simulatorPreview,

      };
    }
  }, [isMobile, isTablet]);

  return (
    <ContentWrapper>
      <div data-testid="simulator-landing-wrapper" className={classes.root}>
        <a
          data-testid="inner-container"
          className={classes.container}
          href={InternalLinks.simulatorAom1d}
        >
          <div className={classes.content}>
            <h2 data-testid="simulator-landing-title" className={classes.sectionTitle}>
              {intl.formatMessage(
                { id: 'simulator.banner.title' },
                {
                  sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
                  noWrap: (chunks: ReactNode) => <span className={classes.noWrap}>{chunks}</span>,
                  noBreak: <>&nbsp;</>,
                },
              )}
            </h2>
          </div>
          <div
            className={classes.imgContainer}
            data-testid="simulator-landing-image"
            aria-hidden="true"
          >
            <img src={image.src} alt="" width={image.width} height={image.height} />
          </div>
        </a>
      </div>
    </ContentWrapper>
  );
};
